import React from 'react';
import { EventOwner } from '../../pages/admin/event_owners/index.page';
import CustomMultiSelect from './CustomMultiSelect';

interface OwnersMultiSelectProps {
  eventOwners: EventOwner[];
  selectedOwnerIds: string[];
  onChange: (ownerIds: string[]) => void;
  placeholder?: string;
}

const OwnersMultiSelect: React.FC<OwnersMultiSelectProps> = ({
  eventOwners,
  selectedOwnerIds,
  onChange,
  placeholder = "Select event owners"
}) => {
  // Convert eventOwners to the format expected by CustomMultiSelect
  const options = eventOwners.map(owner => ({
    label: owner.name,
    value: owner.id?.toString() || '',
    initials: owner.name.charAt(0).toUpperCase(),
    description: owner.email
  }));

  return (
    <CustomMultiSelect
      options={options}
      selectedValues={selectedOwnerIds}
      onChange={onChange}
      placeholder={placeholder}
      colorPalette={['#EB1964', '#F26B3A', '#3AA5F2', '#FFC299']}
    />
  );
};

export default OwnersMultiSelect;
